import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

/* เปิดหน้าแสดงเอกสารจากที่ไหนก็ได้ (ใช้กับลิงก์รหัสเอกสารในหน้ารายงาน)

   ไม่ใช้ replace เพื่อให้ปุ่ม "กลับ" ของหน้าเอกสาร (useGoBack)
   และปุ่มย้อนกลับของเบราว์เซอร์ พากลับมาหน้ารายงานที่กดมา */
const baseConfig = (title, code) => ({
  config: { title, action: "view", code, textOk: null, textCancel: null },
});

export default function useOpenDoc() {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      openJo: (code) =>
        code &&
        navigate("/ERP/job-order/view", { state: baseConfig("Job Order", code) }),

      openPo: (code) =>
        code &&
        navigate("/ERP/purchase-order/view", {
          state: baseConfig("ใบสั่งซื้อ", code),
        }),

      openGr: (code) =>
        code &&
        navigate("/ERP/goods-receipt/view", {
          state: baseConfig("ใบรับสินค้า", code),
        }),

      /* Production Order รับ config.record.pdcode ไม่เหมือนหน้าอื่น */
      openPd: (code) =>
        code &&
        navigate("/ERP/product-order/view", {
          state: { config: { title: "Production Order", action: "view", record: { pdcode: code } } },
        }),
    }),
    [navigate]
  );
}
